import useSWR from "swr";
import { Company } from "../../features/users/models/company.model";
import usePermissions from "./usePermissions";

export const useCompanies = () => {
    const { mutatePermissions } = usePermissions();

    const {
        data = [],
        error,
        isLoading,
        mutate,
    } = useSWR("/api/space-management/v1/companies");

    const handleMutate = () => {
        mutatePermissions();
        mutate();
    };

    return {
        companies: Array.isArray(data) ? (data as Company[]) : [],
        isLoadingCompanies: isLoading,
        isError: error,
        mutateCompanies: handleMutate,
    };
};
